module.exports = __webpack_public_path__ + "img/leader.4c4f75de.png";